export default __webpack_public_path__ + "static/media/talks_icon.6858ea2a.svg";